export const SET_ORGANIZERS = 'SET_ORGANIZERS';
export const SET_MORE_ORGANIZERS = 'SET_MORE_ORGANIZERS';
export const POP_ORGANIZER = 'POP_ORGANIZER';
export const EXCLUDE_ORGANIZER = 'EXCLUDE_ORGANIZER';
export const APPEND_ORGANIZERS_FOR_CAT = 'APPEND_ORGANIZERS_FOR_CAT';
export const VIEW_ORGANIZER = 'VIEW_ORGANIZER';
export const SET_ORGANIZER_CATEGORIES = 'SET_ORGANIZER_CATEGORIES';
